import FinnWidget from '@eiendomsprofil/finn-widget-web';
import PropTypes from 'prop-types';
import React from 'react';
import { trackEventNeighbourhoodProfile } from 'common/lib/helpers/trackingService';

const NeighbourhoodProfile = ({ finnkode }) => (
    <FinnWidget
        endpoint={`/realestate/neighborhood-api.json?finnkode=${finnkode}`}
        config={{
            resizeThrottleMs: 150,
            scrollThrottleMs: 66,
        }}
        onLoad={() => {
            trackEventNeighbourhoodProfile();
        }}
        onScrollStarted={() => {
            trackEventNeighbourhoodProfile('scroll', 'first');
        }}
        onScrolledToEnd={() => {
            trackEventNeighbourhoodProfile('scroll', 'last');
        }}
    />
);

NeighbourhoodProfile.propTypes = {
    finnkode: PropTypes.number.isRequired,
};

export default NeighbourhoodProfile;
